import { filterClasses, warn } from "@swivl-mono/helpers";
import { Channel, EscalationInterface, EscalationStatus } from "@swivl-mono/types";
import { Button, ButtonColor, ButtonVariant } from "@swivl-mono/ui";
import { HiExclamationTriangle } from "react-icons/hi2";
import { ImPhone, ImPhoneHangUp } from "react-icons/im";
import { useNavigate } from "react-router-dom";
import { ChannelColors } from "../../Helpers/Conversations/Conversations.Helper";
import useHasPendingUpdates from "../../Hooks/useHasPendingUpdates";
import { Member } from "../../Models/Member/Member.Current";
import { PendingUpdateType } from "../../Models/Pending/Pending.Model";
import { UsersModel } from "../../Models/Users/Users.Model";
import { CircularCountdown } from "../CircularCountdown/CircularCountdown";

interface Props {
  escalation: EscalationInterface;
}

const classNames = {
  [Channel.SMS]: {
    countdown: {
      text: "fill-black",
      progressCircle: "stroke-teal-450",
    },
    icon: "fill-teal-450",
  },
  [Channel.WEB]: {
    countdown: {
      text: "fill-black",
      progressCircle: "stroke-orange-500",
    },
    icon: "fill-orange-500",
  },
  [Channel.VOICE]: {
    countdown: {
      text: "fill-white",
      progressCircle: "stroke-white",
    },
    icon: "fill-amber-450",
  },
}
const MessageText = {
  [Channel.SMS]: { new: "New SMS Escalation" },
  [Channel.WEB]: { new: "New Web Escalation" },
  [Channel.VOICE]: { new: "New Voice Escalation" },
}


export function ToastEscalation(props: Props) {
  const { escalation } = props;
  const navigate = useNavigate();
  const isPending = useHasPendingUpdates([{ type: PendingUpdateType.SESSION_ESCALATION, id: escalation.sessionId }]);

  if (!escalation) {
    warn("No escalation found for ID:", escalation);
    return null;
  }
  const isAssigned = escalation
    && escalation.status === EscalationStatus.ASSIGNED
    && escalation.assignedMemberId === Member.id;

  const handleAcceptOrView = () => {
    // NotificationsModel.acknowledgeNotification(notification);
    if (escalation.channel === Channel.SMS) {
      navigate(`/conversations/user/${escalation.userId}?channel=sms`);
    } else if (escalation.channel === Channel.WEB) {
      navigate(`/conversations/user/${escalation.userId}`);
    } else if (escalation.channel === Channel.VOICE) {
      navigate(`/conversations/user/${escalation.userId}?channel=voice`);
    }
    if (isAssigned) {
      UsersModel.acceptEscalation(escalation);
    } else {
      UsersModel.acknowledgeEscalation(escalation);
    }
  }

  const handleRejectOrDismiss = () => {
    if (isAssigned) {
      UsersModel.ignoreEscalation(escalation);
    } else {
      UsersModel.acknowledgeEscalation(escalation);

    }
  }

  const isVoice = escalation.channel === Channel.VOICE;

  return (
    <>
      <div className="flex gap-4 items-center">
        {isAssigned ? (
          <CircularCountdown
            classNames={classNames[escalation.channel].countdown}
            startTime={escalation.assignedTimestamp || 0}
            timeUntilZero={escalation?.nextAgentTimestamp || 0}
          />
        ) : <HiExclamationTriangle className={filterClasses("size-[25px]", classNames[escalation.channel].icon)} />}
        <div className="flex flex-col justify-center">
          <span className="font-semibold">{isAssigned ? MessageText[escalation.channel].new : "You Missed This One"}</span>
          <span className="text-grey-600">{escalation?.user?.name || ""}</span>
        </div>
      </div>

      <div className="flex gap-2">
        <Button
          color={isVoice ? (isAssigned ? ButtonColor.RED : ButtonColor.WHITE) : ButtonColor.TRANSPARENT}
          loading={isPending}
          onClick={handleRejectOrDismiss}
          variant={isVoice && isAssigned ? ButtonVariant.PRIMARY : ButtonVariant.GHOST}
          leftIcon={isVoice && isAssigned ? <ImPhoneHangUp className="size-4" /> : null}
        >
          {isAssigned ? "Reject" : "Dismiss"}
        </Button>

        <Button
          color={isVoice && isAssigned ? ButtonColor.TEAL : ChannelColors[escalation.channel].buttonColor}
          loading={isPending}
          onClick={handleAcceptOrView}
          leftIcon={isVoice && isAssigned ? <ImPhone className="size-4" /> : null}
        >
          {isAssigned ? "Accept" : "View"}
        </Button>
      </div>
    </>
  )
}
